import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch, setToken } from '../dppApi';
import '../App.css';

const bloomMark = process.env.PUBLIC_URL + '/BloomFavicon.png';

// Send a freshly authenticated account to its home based on the role the
// shared /api/login endpoint reports.
const homeForRole = (role) => (role === 'brand' ? '/brand/dashboard' : '/user/collection');

// Brand login / registration. Login uses the shared /api/login (which accepts
// either account type and reports the role), so a brand or owner who lands on
// this page still ends up in the right place. Registration stays brand-specific.
const BrandAuth = () => {
    const navigate = useNavigate();
    const [mode, setMode] = useState('login'); // 'login' | 'register'
    const [form, setForm] = useState({ name: '', email: '', password: '' });
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);

    const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setBusy(true);
        try {
            if (mode === 'login') {
                const data = await apiFetch('/api/login', {
                    method: 'POST', body: { email: form.email, password: form.password },
                });
                setToken(data.role, data.token);
                navigate(homeForRole(data.role));
            } else {
                const data = await apiFetch('/api/brand/register', { method: 'POST', body: form });
                setToken('brand', data.token);
                navigate('/brand/dashboard');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="auth-page">
            <img className="auth-mark" src={bloomMark} alt="Bloom" />
            <form className="auth-card" onSubmit={handleSubmit}>
                <h1 className="auth-title">{mode === 'login' ? 'Brand login' : 'Create a brand account'}</h1>
                <p className="auth-sub">Create and manage your passports</p>

                {mode === 'register' && (
                    <input className="auth-input" placeholder="Brand name" value={form.name}
                        onChange={update('name')} required />
                )}
                <input className="auth-input" type="email" placeholder="Email" value={form.email}
                    onChange={update('email')} required />
                <input className="auth-input" type="password" placeholder="Password" value={form.password}
                    onChange={update('password')} required />

                {error && <p className="auth-error">{error}</p>}

                <button className="auth-submit" type="submit" disabled={busy}>
                    {busy ? 'Please wait…' : (mode === 'login' ? 'Log in' : 'Create account')}
                </button>

                <button type="button" className="auth-toggle"
                    onClick={() => { setError(null); setMode(mode === 'login' ? 'register' : 'login'); }}>
                    {mode === 'login' ? "Need an account? Sign up" : 'Have an account? Log in'}
                </button>
            </form>
            <footer className="site-footer">© {new Date().getFullYear()} Bloom. All rights reserved.</footer>
        </div>
    );
};

export default BrandAuth;
